/**
 * @generated SignedSource<<5d1bebb5ffeafbc614d27436dec31889>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectStateValue = "archived" | "at_risk" | "cancelled" | "done" | "off_track" | "on_track" | "paused" | "pending";
export type TrackViewEvent = "DIRECT" | "INDIRECT" | "SKIP";
export type ProjectViewQuery$variables = {
  key: string;
  trackViewEvent?: TrackViewEvent | null;
};
export type ProjectViewQuery$data = {
  readonly project: {
    readonly key: string;
    readonly members: {
      readonly " $fragmentSpreads": FragmentRefs<"utils_isUserInList">;
    } | null;
    readonly name: string;
    readonly state: {
      readonly value: ProjectStateValue | null;
    } | null;
    readonly uuid: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectArchivedPanel" | "ProjectContent" | "useRedirectToDefaultTab">;
  } | null;
};
export type ProjectViewQuery = {
  response: ProjectViewQuery$data;
  variables: ProjectViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "trackViewEvent"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  },
  {
    "kind": "Variable",
    "name": "trackViewEvent",
    "variableName": "trackViewEvent"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "key"
},
v5 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v6 = {
  "concreteType": "ProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "ari"
},
v9 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v10 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v11 = {
  "kind": "ScalarField",
  "name": "picture"
},
v12 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v13 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v14 = {
  "kind": "ScalarField",
  "name": "targetDate"
},
v15 = {
  "kind": "ScalarField",
  "name": "count"
},
v16 = {
  "kind": "ScalarField",
  "name": "summary"
},
v17 = {
  "kind": "ScalarField",
  "name": "title"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectViewQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v1/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "members",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "utils_isUserInList",
                "selections": [
                  {
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "argumentDefinitions": []
              }
            ]
          },
          (v6/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "ProjectArchivedPanel"
          },
          {
            "kind": "FragmentSpread",
            "name": "ProjectContent"
          },
          {
            "kind": "FragmentSpread",
            "name": "useRedirectToDefaultTab"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectViewQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v1/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "members",
            "plural": false,
            "selections": [
              {
                "concreteType": "UserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "ScalarField",
            "name": "watching"
          },
          {
            "kind": "ScalarField",
            "name": "userUpdateCount"
          },
          {
            "concreteType": "TownsquareProjectCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "theWhat"
          },
          {
            "kind": "ScalarField",
            "name": "theWhy"
          },
          {
            "kind": "ScalarField",
            "name": "theMeasurement"
          },
          {
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v7/*: any*/),
              {
                "concreteType": "WorkspaceAIConfig",
                "kind": "LinkedField",
                "name": "aiConfig",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "enabled"
                  }
                ]
              }
            ]
          },
          (v8/*: any*/),
          {
            "concreteType": "CommentConnection",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
              {
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v9/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "commentText"
                      },
                      (v10/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v3/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "accountStatus"
                              },
                              (v12/*: any*/)
                            ]
                          },
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v13/*: any*/)
            ]
          },
          (v14/*: any*/),
          {
            "kind": "ScalarField",
            "name": "targetDateConfidence"
          },
          {
            "kind": "ScalarField",
            "name": "latestUpdateDate"
          },
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              (v15/*: any*/)
            ]
          },
          (v10/*: any*/),
          {
            "kind": "ScalarField",
            "name": "startDate"
          },
          {
            "concreteType": "ProjectUpdate",
            "kind": "LinkedField",
            "name": "latestUserUpdate",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v16/*: any*/),
              {
                "concreteType": "UpdateNote",
                "kind": "LinkedField",
                "name": "notes",
                "plural": true,
                "selections": [
                  (v17/*: any*/),
                  (v16/*: any*/),
                  (v7/*: any*/)
                ]
              },
              (v7/*: any*/)
            ]
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                  },
                  {
                    "kind": "Literal",
                    "name": "pendingUpdateAttatchment",
                    "value": true
                  }
                ],
                "concreteType": "MilestoneConnection",
                "kind": "LinkedField",
                "name": "milestones_extension",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "MilestoneEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Milestone",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v2/*: any*/),
                          (v17/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "targetDateType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "status"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "milestones_extension(first:10,pendingUpdateAttatchment:true)"
              }
            ]
          },
          {
            "args": [
              {
                "kind": "Literal",
                "name": "hasUpdateId",
                "value": false
              }
            ],
            "concreteType": "ProjectChangelogItemConnection",
            "kind": "LinkedField",
            "name": "changelog",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              {
                "concreteType": "ProjectChangelogItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ProjectChangelogItem",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "newValue"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "oldValue"
                      },
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "changelog(hasUpdateId:false)"
          },
          {
            "concreteType": "DraftUpdate",
            "kind": "LinkedField",
            "name": "draftUpdate",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "input"
              },
              {
                "kind": "ScalarField",
                "name": "modifiedDate"
              },
              {
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "UserPII",
                    "kind": "LinkedField",
                    "name": "pii",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v3/*: any*/),
                      (v11/*: any*/)
                    ]
                  },
                  (v7/*: any*/)
                ]
              },
              (v7/*: any*/),
              (v13/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "url"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8b1e17d0cc42ec22b9f9f52be9ef6c12",
    "id": null,
    "metadata": {},
    "name": "ProjectViewQuery",
    "operationKind": "query",
    "text": "query ProjectViewQuery(\n  $key: String!\n  $trackViewEvent: TrackViewEvent\n) {\n  project: projectByKey(key: $key, trackViewEvent: $trackViewEvent) {\n    uuid\n    name\n    key\n    members {\n      ...utils_isUserInList\n    }\n    state {\n      value\n    }\n    ...ProjectArchivedPanel\n    ...ProjectContent\n    ...useRedirectToDefaultTab\n    id\n  }\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment DraftProjectUpdate on DraftUpdate {\n  input\n  modifiedDate\n  author {\n    pii {\n      accountId\n      name\n      picture\n    }\n    id\n  }\n}\n\nfragment NewProjectUpdate on Project {\n  id\n  key\n  uuid\n  workspace {\n    uuid\n    id\n  }\n  watchers {\n    count\n  }\n  creationDate\n  startDate\n  targetDate\n  state {\n    value\n  }\n  latestUserUpdate {\n    editDate\n    creationDate\n    summary\n    notes {\n      title\n      summary\n      id\n    }\n    id\n  }\n  ...ProjectTargetDateAutoUpdated\n  draftUpdate {\n    ...DraftProjectUpdate\n    input\n    id\n  }\n  url\n}\n\nfragment ProjectAboutTab on Project {\n  capabilities {\n    canEditMetadata\n  }\n  ...ProjectDescription\n  ...ProjectComments\n}\n\nfragment ProjectArchivedPanel on Project {\n  id\n  state {\n    value\n  }\n}\n\nfragment ProjectComments on Project {\n  id\n  uuid\n  ari\n  workspace {\n    uuid\n    id\n  }\n  comments {\n    edges {\n      node {\n        id\n      }\n    }\n    ...Comments\n  }\n}\n\nfragment ProjectContent on Project {\n  watching\n  userUpdateCount\n  ...ProjectAboutTab\n  ...ProjectUpdatesTab\n}\n\nfragment ProjectDescription on Project {\n  id\n  uuid\n  name\n  theWhat\n  theWhy\n  theMeasurement\n  workspace {\n    uuid\n    id\n  }\n}\n\nfragment ProjectTargetDateAutoUpdated on Project {\n  key\n  targetDate\n  changelog(hasUpdateId: false) {\n    count\n    edges {\n      node {\n        newValue\n        oldValue\n        id\n      }\n    }\n  }\n}\n\nfragment ProjectUpdateComposer on Project {\n  ...ProjectUpdateDueDateContext\n  ...NewProjectUpdate\n  draftUpdate {\n    ...DraftProjectUpdate\n    id\n  }\n  id\n  uuid\n  workspace {\n    uuid\n    aiConfig {\n      enabled\n    }\n    id\n  }\n}\n\nfragment ProjectUpdateDueDateContext on Project {\n  state {\n    value\n  }\n  latestUpdateDate\n}\n\nfragment ProjectUpdatesTab on Project {\n  key\n  state {\n    value\n  }\n  watching\n  targetDate\n  targetDateConfidence\n  ...ProjectUpdateComposer\n  draftUpdate {\n    id\n  }\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment useRedirectToDefaultTab on Project {\n  watching\n  key\n}\n\nfragment utils_isUserInList on UserConnection {\n  edges {\n    node {\n      aaid\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d7f39a8344b315b545025ea047eac25b";

export default node;
